import api from './api';

export interface ReferralConfig {
  bonus_referrer_pontos: number;
  bonus_convidado_pontos: number;
  bonus_referrer_cve: number;
  bonus_convidado_cve: number;
  limite_utilizadores: number;
  ativo: boolean;
}

export interface ReferralStats {
  total_referrers: number;
  total_convites: number;
  convites_aceites: number;
  bonus_pago_pontos: number;
  top_referrer: {
    user_id: string;
    codigo: string;
    total_convites: number;
    total_bonus: number;
    nome: string;
  } | null;
}

export interface Referrer {
  user_id: string;
  codigo: string;
  total_convites: number;
  total_bonus: number;
  created_at: string;
  nome: string;
  username: string;
  email: string;
}

export interface Convite {
  id: number;
  referrer_id: string;
  convidado_id: string | null;
  codigo: string;
  status: string;
  bonus_pago: number;
  created_at: string;
  accepted_at: string | null;
  referrer_nome: string;
  referrer_email: string;
  convidado_nome: string | null;
  convidado_email: string | null;
}

class MarketingReferralService {
  async setup() { await api.post('/admin/marketing/referral/setup'); }
  async stats(): Promise<ReferralStats> {
    const res = await api.get('/admin/marketing/referral/stats');
    return res.data.data;
  }
  async listReferrers(search?: string): Promise<Referrer[]> {
    const qs = new URLSearchParams();
    if (search) qs.append('search', search);
    const res = await api.get(`/admin/marketing/referral/referrers?${qs}`);
    return res.data.data || [];
  }
  async getReferrer(userId: string): Promise<Referrer & { convites: Convite[] }> {
    const res = await api.get(`/admin/marketing/referral/referrers/${userId}`);
    return res.data.data;
  }
  async listConvites(status?: string, search?: string): Promise<Convite[]> {
    const qs = new URLSearchParams();
    if (status) qs.append('status', status);
    if (search) qs.append('search', search);
    const res = await api.get(`/admin/marketing/referral/convites?${qs}`);
    return res.data.data || [];
  }
  async invalidateConvite(id: number) {
    await api.post(`/admin/marketing/referral/convites/${id}/invalidate`);
  }
  async getConfig(): Promise<ReferralConfig> {
    const res = await api.get('/admin/marketing/referral/config');
    return res.data.data;
  }
  async updateConfig(partial: Partial<ReferralConfig>): Promise<ReferralConfig> {
    const res = await api.put('/admin/marketing/referral/config', partial);
    return res.data.data;
  }
}

export default new MarketingReferralService();
